/* theme.js
 * Hooks into:
 *   [data-menu-toggle] / [data-nav-drawer] / [data-menu-close] — header drawer
 *   [data-cart-count]                                            — cart count bubble
 *   .reveal                                                      — scroll reveal fallback
 * Plain ES2020, no dependencies. Loaded with defer; pages work without JS.
 */
(function () {
  'use strict';

  /* ---------- Cart count helper (used by header + other briefs) ---------- */
  var NexoraCart = {
    refresh: function () {
      if (!window.fetch) return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var count = (cart && typeof cart.item_count === 'number') ? cart.item_count : 0;
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = String(count);
            el.setAttribute('data-empty', count === 0 ? 'true' : 'false');
          });
        })
        .catch(function () { /* offline or blocked: leave the server-rendered value */ });
    }
  };
  window.NexoraCart = NexoraCart;

  /* ---------- Header drawer ---------- */
  function initDrawer() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var drawer = document.querySelector('[data-nav-drawer]');
    if (!toggle || !drawer) return;

    var panel = drawer.querySelector('.nav-drawer__panel');
    var closers = drawer.querySelectorAll('[data-menu-close]');
    var lastFocused = null;

    function focusables() {
      return Array.prototype.slice.call(
        panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
      );
    }

    function open() {
      lastFocused = document.activeElement;
      drawer.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('has-drawer');
      var nodes = focusables();
      if (nodes.length) nodes[0].focus();
      document.addEventListener('keydown', onKeydown, true);
    }

    function close() {
      drawer.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('has-drawer');
      document.removeEventListener('keydown', onKeydown, true);
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      var nodes = focusables();
      if (!nodes.length) return;
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    toggle.addEventListener('click', function () {
      if (toggle.getAttribute('aria-expanded') === 'true') {
        close();
      } else {
        open();
      }
    });

    closers.forEach(function (el) {
      el.addEventListener('click', close);
    });
  }

  /* ---------- Reveal fallback ---------- */
  function initReveal() {
    var supportsViewTimeline = window.CSS && CSS.supports && CSS.supports('animation-timeline', 'view()');
    if (supportsViewTimeline || !('IntersectionObserver' in window)) return;

    document.documentElement.classList.add('no-view-timeline');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });

    document.querySelectorAll('.reveal').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* Hero film: plays once on load, then its time follows scroll position.
     Hooks into <video data-hero-video> rendered by sections/hero.liquid.
     Needs the video host to support HTTP range requests (Shopify CDN does). */
  function initHeroScrub() {
    var v = document.querySelector('[data-hero-video]');
    if (!v) return;
    if (window.innerWidth < 900) { return; }
    if (v.dataset.src) { v.src = v.dataset.src; }
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { v.pause(); return; }
    var target = 0;
    var raf = 0;
    function tick() {
      raf = 0;
      var d = target - v.currentTime;
      if (Math.abs(d) > 0.03) {
        v.currentTime = v.currentTime + d * 0.3;
        raf = requestAnimationFrame(tick);
      }
    }
    function onScroll() {
      if (!v.duration) return;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var h = Math.max(1, v.parentElement.getBoundingClientRect().height);
      var p = Math.min(1, Math.max(0, y / (h * 1.15)));
      v.pause();
      target = p * v.duration;
      if (!raf) raf = requestAnimationFrame(tick);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    var played = v.play();
    if (played && played.catch) played.catch(function () {});
  }

  function initMobileBar() {
    var b = document.querySelector('[data-bar-menu]');
    var t = document.querySelector('[data-menu-toggle]');
    if (b && t) b.addEventListener('click', function () { t.click(); });
  }

  function init() {
    initMobileBar();
    initDrawer();
    initReveal();
    initHeroScrub();
    NexoraCart.refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();